import * as React from "react";
import styled from "styled-components";
import useHasEntityPermissionByGRN from "hooks/useHasEntityPermissionByGRN";
import { RestrictedAccessTooltip, Link } from "components/common";
import capabilityLabel from "logic/permissions/capabilityLabel";
import useShowRouteFromGRN from "routing/hooks/useShowRouteFromGRN";
import usePluggableSharedEntityTableElements from "hooks/usePluggableSharedEntityTableElements";
import OwnersCell from "./OwnersCell";
const NameColumnWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const SharedEntitiesOverviewItem = ({ capabilityTitle, sharedEntity: { owners, title, type, id } }) => {
  const entityRoute = useShowRouteFromGRN(id);
  const { getPluggableTableCells, pluggableAttributes } = usePluggableSharedEntityTableElements();
  const hasReadPermission = useHasEntityPermissionByGRN(id, "read");
  const hasEditPermission = useHasEntityPermissionByGRN(id, "edit");
  const hasRequiredPermission = () => {
    switch (type) {
      case "user":
      case "team":
        return hasEditPermission;
      default:
        return hasReadPermission;
    }
  };
  return /* @__PURE__ */ React.createElement("tr", { key: title + type }, /* @__PURE__ */ React.createElement("td", { className: "limited" }, /* @__PURE__ */ React.createElement(NameColumnWrapper, null, hasRequiredPermission() ? /* @__PURE__ */ React.createElement(Link, { to: entityRoute }, title) : /* @__PURE__ */ React.createElement(React.Fragment, null, title, /* @__PURE__ */ React.createElement(RestrictedAccessTooltip, { entityName: type, capabilityName: "view" })))), /* @__PURE__ */ React.createElement("td", { className: "limited" }, type), /* @__PURE__ */ React.createElement(OwnersCell, { owners }), /* @__PURE__ */ React.createElement("td", { className: "limited" }, capabilityLabel(capabilityTitle)), pluggableAttributes && getPluggableTableCells(id, type));
};
export default SharedEntitiesOverviewItem;
